import { render } from "./Erfassen.vue?vue&type=template&id=07490328&scoped=true"
import script from "./Erfassen.vue?vue&type=script&lang=js"
export * from "./Erfassen.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Bleckmann\\lions-adventskalender-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07490328"]])

export default __exports__